import { render, staticRenderFns } from "./GCheckListTable.vue?vue&type=template&id=cbfa80cc&scoped=true&"
import script from "./GCheckListTable.vue?vue&type=script&lang=ts&"
export * from "./GCheckListTable.vue?vue&type=script&lang=ts&"
import style0 from "./GCheckListTable.vue?vue&type=style&index=0&id=cbfa80cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfa80cc",
  null
  
)

export default component.exports